document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-menu]');

if (menuToggle && menu) {
  menuToggle.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.textContent = isOpen ? window.MMYTranslations.close : window.MMYTranslations.menu;
  });
}

const backToTop = document.querySelector('[data-back-to-top]');

if (backToTop) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const updateBackToTopVisibility = () => backToTop.classList.toggle('is-visible', window.scrollY > 420);

  window.addEventListener('scroll', updateBackToTopVisibility, { passive: true });
  backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }));
  updateBackToTopVisibility();
}

document.querySelectorAll('[data-banner-carousel]').forEach((carousel) => {
  const viewport = carousel.querySelector('[data-banner-viewport]');
  const track = carousel.querySelector('[data-banner-track]');
  const slides = Array.from(carousel.querySelectorAll('[data-banner-slide]'));
  const buttons = Array.from(carousel.querySelectorAll('[data-banner-button]'));

  if (!viewport || !track || slides.length < 2 || buttons.length !== slides.length) return;

  let currentSlide = 0;
  let autoplayTimer;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const resizeViewport = () => {
    viewport.style.height = `${slides[currentSlide].offsetHeight}px`;
  };

  const showSlide = (index) => {
    currentSlide = (index + slides.length) % slides.length;
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    slides.forEach((slide, slideIndex) => {
      slide.setAttribute('aria-hidden', String(slideIndex !== currentSlide));
    });
    buttons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === currentSlide;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', String(isActive));
    });
    resizeViewport();
  };

  const stopAutoplay = () => {
    window.clearInterval(autoplayTimer);
    autoplayTimer = undefined;
  };
  const startAutoplay = () => {
    if (!reduceMotion && !autoplayTimer) autoplayTimer = window.setInterval(() => showSlide(currentSlide + 1), 6500);
  };

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      stopAutoplay();
      showSlide(index);
      startAutoplay();
    });
  });

  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);
  carousel.addEventListener('focusin', stopAutoplay);
  carousel.addEventListener('focusout', startAutoplay);
  window.addEventListener('resize', resizeViewport, { passive: true });
  slides.forEach((slide) => slide.querySelector('img')?.addEventListener('load', resizeViewport));

  showSlide(0);
  startAutoplay();
});

document.querySelectorAll('[data-b2b-inquiry-open]').forEach((trigger) => {
  const dialog = document.getElementById(trigger.dataset.b2bInquiryOpen);
  if (!(dialog instanceof HTMLDialogElement)) return;

  const formsValidationTranslations = new Map([
    ['Email is invalid', window.MMYTranslations.invalidEmail],
    ['Minimum allowed value is 30.0', window.MMYTranslations.minimum],
    ['Field is required', window.MMYTranslations.required],
  ]);
  const formsValidationRoots = new WeakSet();

  const translateFormsValidationAlerts = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      const message = node.nodeValue.trim();
      const translation = formsValidationTranslations.get(message);
      if (translation) node.nodeValue = node.nodeValue.replace(message, translation);
      node = walker.nextNode();
    }
  };

  const observeFormsValidationAlerts = () => {
    dialog.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      const root = embed.shadowRoot;
      if (!root || formsValidationRoots.has(root)) return;

      formsValidationRoots.add(root);
      translateFormsValidationAlerts(root);
      new MutationObserver(() => translateFormsValidationAlerts(root)).observe(root, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  };

  observeFormsValidationAlerts();
  customElements.whenDefined('shopify-forms-embed').then(observeFormsValidationAlerts);

  const closeButton = dialog.querySelector('[data-b2b-inquiry-close]');
  trigger.addEventListener('click', () => {
    observeFormsValidationAlerts();
    dialog.showModal();
    closeButton?.focus();
  });
  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !dialog.open) return;
    event.preventDefault();
    dialog.close();
  }, true);
  closeButton?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => trigger.focus());
});

